export default __webpack_public_path__ + "static/media/lens.70d8167f.svg";